__turbopack_context__.v({
  "active": "MortgageInputs-module-scss-module__LH-Dja__active",
  "additionalCosts": "MortgageInputs-module-scss-module__LH-Dja__additionalCosts",
  "additionalCostsTitle": "MortgageInputs-module-scss-module__LH-Dja__additionalCostsTitle",
  "component": "MortgageInputs-module-scss-module__LH-Dja__component",
  "infoIcon": "MortgageInputs-module-scss-module__LH-Dja__infoIcon",
  "inputGroup": "MortgageInputs-module-scss-module__LH-Dja__inputGroup",
  "inputHeader": "MortgageInputs-module-scss-module__LH-Dja__inputHeader",
  "inputLabel": "MortgageInputs-module-scss-module__LH-Dja__inputLabel",
  "inputValue": "MortgageInputs-module-scss-module__LH-Dja__inputValue",
  "jiggle": "MortgageInputs-module-scss-module__LH-Dja__jiggle",
  "nearby": "MortgageInputs-module-scss-module__LH-Dja__nearby",
  "quickSelectButton": "MortgageInputs-module-scss-module__LH-Dja__quickSelectButton",
  "quickSelectButtons": "MortgageInputs-module-scss-module__LH-Dja__quickSelectButtons",
});
